import { connect } from "react-redux";
import GroupComponent from "../../Components/Groups/GroupComponent";
import { setGroups } from "../../Redux/Actions/GroupsActions";
const mapStateToProps = (state) => ({
      SCOPES: state.reducer.SCOPES,
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
});
const mapDispatchToProps = (dispatch) => ({
  setGroups: (GROUPS) => dispatch(setGroups(GROUPS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(GroupComponent);